import React, { useEffect, useState } from 'react'
import {
    PiCaretDownFill,
    PiCaretUpFill,
    PiCheckCircleFill,
    PiWarningFill,
  } from "react-icons/pi";
import { debittingCountApi, faAppReport, getAllWorkflowMandates, mailReportApi, mailworkFlowReportApi, smsworkFlowReportApi, workFlowReportApi } from '../services';
import moment from 'moment';
import { useParams } from 'react-router';
import ReactPaginate from 'react-paginate';
import LoadingModal from '../components/modals/LoadingModal';

const AllWorkFlowMandates = () => {
    const [allMandates, setAllMandates] = useState([])
    const [loading, setLoading] = useState(false)
    const {mandateId, workflowId} = useParams()
      const [pageCount, setPageCount] = useState(0); // For total pages
        const [currentPage, setCurrentPage] = useState(1); // Current page
        const [limit, setLimit] = useState(10)
        const [workFlowStatus, setWorkFLowStatus] = useState("")
        const [search, setSearch] = useState("")
          const [isLoading, setIsLoading] = useState(false);

    const WORKFLOWSTATUS = {
        BILLER_INITIATED: 1,
        BILLER_AUTHORISED: 2,
        BILLER_REJECTED: 3,
        BILLER_APPROVED: 4,
        BANK_AUTHORIZED: 6,
        BANK_REJECTED: 7,
        BANK_APPROVED: 8,
        BANK_DISAPPROVED: 9,
      };
      
      function getWorkflowStatusLabel(statusCode) {
        const entry = Object.entries(WORKFLOWSTATUS).find(
          ([_, value]) => value === statusCode
        );
      
        if (!entry) return "Unknown Status";
      
        // Convert key to readable format e.g., BILLER_INITIATED => Biller Initiated
        const formatted = entry[0]
          .toLowerCase()
          .split('_')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ');
      
        return formatted;
      }
      

    const numberFormat = (value, toFixed = 2) => {
        const num = Number(value);
        if (Number.isInteger(num)) {
          return num.toLocaleString(); // Handles integer values without decimals
        } else {
          return num
            .toFixed(toFixed) // Ensures the specified number of decimal places
            .replace(/\d(?=(\d{3})+\.)/g, "$&,"); // Adds commas for thousands
        }
      };

      const handleAllMandates = async (page, limit) =>{
        const params = {
            sessionId: mandateId,
            limit: limit,
            page: page,
            workflowStatus: workflowId,
            search: search,
          }
      
          const searchParams = new URLSearchParams()
          // Add parameters only if they are defined and not empty
          Object.entries(params).forEach(([key, value]) => {
            if (value) {
                searchParams.append(key, value);
            }
        });

        await getAllWorkflowMandates(searchParams)
            .then((res)=>{
            //   console.log("all mandates res ", res?.data?.data);
              setAllMandates(res?.data?.data)
              setPageCount(res?.data?.totalPages)
                // setFaReport(res?.data)
            })
            .catch((err) =>{
                console.log('err ', err);
            })
      }

      const handlePageClick = async (data) => {
        setIsLoading(true);
        let selectedPage = data.selected + 1; // react-paginate uses 0-based index, so add 1
        setCurrentPage(selectedPage); // Update current page state
        await handleAllMandates(selectedPage, limit)
        setIsLoading(false);
      };


      useEffect(()=>{
        const initiate = async () =>{
            setLoading(true)
            await handleAllMandates(currentPage, limit)
            setLoading(false)
        }
        initiate()
      },[])

  return (
    <>
      {loading ? (
        <div className="typewriter-container">
          <div class="typewriter">
            <div class="slide">
              <i></i>
            </div>
            <div class="paper"></div>
            <div class="keyboard"></div>
          </div>
          <code style={{ color: "#000" }}>Getting your app ready...</code>
        </div>
      ) : (
    <div style={{overflowX: "auto"}}>

        <form onSubmit={async(e)=> {
            e.preventDefault()
            setIsLoading(true);
            await handleAllMandates(1, 10)
            setIsLoading(false);
        }} style={{display: "flex", justifyContent: "flex-end", padding: "10px 0", gap: "10px"}}>
            <input type="text" onChange={(e)=> setSearch(e.target.value)} style={{border: "1px solid black", borderRadius: "5px", padding: "5px 10px", outline: "none"}} />
            <button type="submit" style={{border: "none", backgroundColor: "#007dcc", color: "white", padding: "0px 10px", borderRadius: "5px"}}>Search</button>
        </form>
      {/* <h5 className='mt-3'>Sms Report</h5> */}
                <table className="fl-table">
                  <thead>
                    <tr style={{ borderBottom: "0.5px solid #f1f1f1" }}>
                      {/* Table header cells */}
                      {/* Modify according to your data structure */}
                      <th width="20%">Mandate Code</th>
                      <th width="20%">Subscriber Code</th>
                      <th>Full Name</th>
                      <th>Amount</th>
                      <th>Agent name</th>
                      <th>Account number</th>
                      <th>WorkFLow Status</th>
                      <th>Created At</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      allMandates?.map((mandate) => (
                        <tr
                          className="tr"
                          key={mandate.id}
                        >
                          <td className="gray-td">{mandate?.mandateCode}</td>
                          <td className="gray-td">{mandate?.contractId}</td>
                          <td className="gray-td">{mandate?.firstName} {mandate?.lastName}</td>
                          <td className="gray-td">{Number(mandate?.premium).toLocaleString()}</td>
                          <td className="gray-td">{mandate?.agentName}</td>
                          
                          <td className="gray-td">{mandate?.accountNumber}</td>
                          <td className="gray-td">{mandate?.workFlowStatusDescription} ({mandate?.workFlowStatus})</td>
                          <td className="gray-td">{moment(mandate?.createdAt).format('DD MMM, YYYY')}</td>
                        </tr>
                      ))}
                  </tbody>
                </table>
                <ReactPaginate
                              previousLabel={"Prev"}
                              nextLabel={"Next"}
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              pageCount={pageCount} // Total pages from API
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={5}
                              onPageChange={handlePageClick}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"}
                              forcePage={currentPage - 1}
                            />
                            <LoadingModal show={isLoading} />
    </div>
      )}
      </>
  )
}

export default AllWorkFlowMandates